import React, { Component } from 'react'
import { TxBottom } from '../../../../components'

class TokenTransfers extends Component {
    render() {
        return <TxBottom {...this.props} />
    }
}

export default TokenTransfers
